/**
 * The id event_service mints for an event created with no Firebase document — `##NO_FIREBASE_ID##--<uuid>`.
 * Same name and value as `NO_FIREBASE_ID_PREFIX` in event_service (`src/models/event/utils.ts`); there
 * is no shared package, so this is a copy and the two must move together.
 */
export const NO_FIREBASE_ID_PREFIX = '##NO_FIREBASE_ID##';

/** Is this the sentinel rather than a real Firebase id? New-stack weddings, general and card events all carry it. */
export const isSyntheticFirebaseId = (firebaseId: string | null | undefined): boolean => !!firebaseId && firebaseId.startsWith(NO_FIREBASE_ID_PREFIX);

/**
 * Will a Firebase-keyed read with this id find anything?
 *
 * The drop-in for `!!eventFirebaseId`: the sentinel is a non-empty string, so a truthiness check
 * says yes and the caller then queries a Firebase-keyed service with an id it has never seen. This is
 * the *data* question. For the *product* question — which stack's screens does this event get —
 * use `useIsNewStackEvent`; the two agree today for everything but a new-stack wedding.
 */
export const hasFirebaseDocument = (firebaseId: string | null | undefined): boolean => !!firebaseId && !isSyntheticFirebaseId(firebaseId);
